









import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    name: "MediaUploadProgress"
})
export default class MediaUploadProgress extends Vue {
    @Prop({required: true}) file: File;
    @Prop({required: true}) progress: number;

    get fileName() {
        return this.file?.name ?? '';
    }
}
